import { useNewCase } from '@/providers/NewCaseProvider';
import { useMountEffect } from '@/hooks/useMountEffect';
import StepTitle from '../StepTitle';
import FileSelector from './FileSelector';
import { classes, getBlocks, getSubtitle } from './utils';

export default function FilesStep() {
  const {
    projectTypeId,
    serviceType,
    selectedFiles,
    onSelectFiles,
    onRemoveFiles,
  } = useNewCase();

  useMountEffect(() => {
    const ignoreDrag = (e: DragEvent) => {
      e.preventDefault();
    };
    window.addEventListener('dragover', ignoreDrag);
    window.addEventListener('drop', ignoreDrag);
    return () => {
      window.removeEventListener('dragover', ignoreDrag);
      window.removeEventListener('drop', ignoreDrag);
    };
  });

  return (
    <div className={classes.section}>
      <StepTitle title="Files" subtitle={getSubtitle(projectTypeId)} />
      <div className={classes.scansBlock}>
        {getBlocks(serviceType).map(({ fileType, title, subtitle }) => (
          <FileSelector
            key={fileType}
            multiple={false}
            fileType={fileType}
            accept=".stl"
            title={title}
            subtitle={subtitle}
            selectedFiles={selectedFiles[fileType]}
            onAddFiles={(files) => onSelectFiles(fileType, files)}
            onRemoveFiles={(uuids) => onRemoveFiles(uuids)}
          />
        ))}
      </div>
    </div>
  );
}
